/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Spinner } from "react-bootstrap";
import Header from "../../Common/Header";

import useHiringManagerAcceptMentor from "./useHiringManagerAcceptMentor";
import "./HiringManagerAcceptMentor.scss";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    applicationDetails,
    loading,
    loadingError,
    acceptLoading,
    onAcceptRejectClick,
    onViewMentorProfileClick,
  } = useHiringManagerAcceptMentor();
  return (
    <MainLayout>
      {loading ? (
        <div className="d-fkex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <div className="mentor-information-wrapper mt-5 shadow-sm bg-white border-6 rounded-lg overflow-hidden  mx-auto">
            {applicationDetails?.id && (
              <div className="mentor-information">
                <h3 className="bg-grey-2 p-3">
                  <span
                    className="text-primary text-underline cursor-pointer mr-2 text-capitalize"
                    onClick={(e) =>
                      onViewMentorProfileClick(
                        applicationDetails?.id
                      )
                    }
                  >
                    {" "}
                    {applicationDetails?.mentor_details &&
                      applicationDetails.mentor_details?.full_name}
                  </span>
                  has applied for mentoring of the following job
                </h3>
                <ul className="text-grey-4 bg-grey p-3">
                  <li className="mb-2">
                    <span className="font-weight-bold mr-3 text-dark-2">
                      Job Title
                    </span>
                    <span className="text-capitalize d-inline-block">
                      {applicationDetails?.job_details &&
                        applicationDetails.job_details?.title}
                    </span>
                  </li>
                  <li className="mb-2">
                    <span className="font-weight-bold mr-3 text-dark-2">
                      Department
                    </span>
                    <span className="text-capitalize d-inline-block">
                      {applicationDetails?.job_details &&
                        applicationDetails.job_details?.job_function}
                    </span>
                  </li>
                  <li className="mb-2">
                    <span className="font-weight-bold mr-3 text-dark-2">
                      Location
                    </span>
                    <span className="text-capitalize d-inline-block">
                      {applicationDetails?.job_details &&
                        applicationDetails.job_details?.state_name}
                      ,
                      {applicationDetails?.job_details &&
                        applicationDetails.job_details?.country_name}
                    </span>
                  </li>
                  <li className="mb-2">
                    <span className="font-weight-bold mr-3 text-dark-2">
                      Salary Range
                    </span>
                    <span className="text-capitalize d-inline-block">
                      {applicationDetails?.job_details &&
                        applicationDetails.job_details?.payment_from}
                    </span>
                  </li>
                </ul>
                <p className="text-grey-4  bg-grey p-3 mb-0">
                  Please click below to sign into your account so that you can
                  collaborate
                </p>

                {acceptLoading ? (
                  <Spinner animation="border" variant="primary" />
                ) : (
                  <>
                    {applicationDetails?.application_status == "rejected" ?
                      <div className="mentor-information  border-6  bg-grey p-3">
                        <p className="text-danger font-weight-bold font-italic fs-14">Mentor has been rejected.</p>
                      </div> :
                      applicationDetails?.job_details &&
                        applicationDetails.job_details?.mentor_name === null ? (
                        <div className="flex align-items-center   bg-grey p-3">
                          <button
                            className="btn btn-primary"
                            onClick={() => onAcceptRejectClick("selected")}
                          >
                            Accept
                          </button>
                          <button
                            className="btn ml-4 btn-dark"
                            onClick={() => onAcceptRejectClick("rejected")}
                          >
                            Reject
                          </button>
                        </div>
                      ) : (
                        <div className="mentor-information  border-6  bg-grey p-3">
                          <p className="text-primary font-weight-bold font-italic fs-14">
                            <span className="text-capitalize">
                              {applicationDetails?.job_details &&
                                applicationDetails.job_details?.mentor_name}{" "}
                            </span>
                            has been assigned to the job
                          </p>
                        </div>
                      )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {loadingError && loadingError.length > 0 && (
        <div className="mentor-information bg-white border-6 p-3">
          <p className="text-danger">
            {loadingError === "Successfully Updated" ? null : loadingError}
          </p>
        </div>
      )}
    </MainLayout>
  );
};
